import { render, staticRenderFns } from "./VehicleTyreConfiguration.vue?vue&type=template&id=71bb9be2&scoped=true&"
import script from "./VehicleTyreConfiguration.vue?vue&type=script&lang=js&"
export * from "./VehicleTyreConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./VehicleTyreConfiguration.vue?vue&type=style&index=0&id=71bb9be2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bb9be2",
  null
  
)

export default component.exports